import React from 'react';
import { Link } from 'react-router-dom';
import { Users, BadgePercent, Share2, ArrowRight } from 'lucide-react';

// Compact landing-page teaser for Group Buy Now, with a Learn more link to the
// full explainer at /group-buy.
const GroupBuyPromo = () => {
  return (
    <section className="py-14 px-4 bg-gradient-to-br from-emerald-50 via-white to-teal-50">
      <div className="max-w-5xl mx-auto">
        <div className="grid md:grid-cols-2 gap-8 items-center">
          <div>
            <div className="inline-flex items-center gap-2 bg-emerald-100 text-emerald-700 px-3 py-1 rounded-full text-sm font-medium mb-4">
              <Users className="w-4 h-4" /> Group Buy Now
            </div>
            <h2 className="text-3xl font-bold text-gray-900 mb-3">Team up with neighbors. Pay less.</h2>
            <p className="text-gray-600 mb-6">
              Join or start a group for the same service — the more people who join, the bigger the
              discount providers offer. One provider, many customers, a better price for everyone.
            </p>
            <div className="flex flex-wrap items-center gap-3">
              <Link to="/group-buy">
                <span className="inline-flex items-center gap-1 px-5 py-2.5 rounded-md bg-emerald-700 text-white font-medium hover:bg-emerald-800 transition-colors">
                  Learn How Group Buy works <ArrowRight className="w-4 h-4" />
                </span>
              </Link>
              <Link to="/groups/new" className="text-emerald-700 font-medium hover:text-emerald-900">
                Start a group
              </Link>
            </div>
          </div>

          <div className="grid gap-3">
            {[
              { icon: Share2, title: 'Share an invite link', body: 'Anyone can view a group; they log in only to join.' },
              { icon: Users, title: 'Gather your group', body: 'Members nearby join — or anyone in the US for nationwide services.' },
              { icon: BadgePercent, title: 'Unlock bigger discounts', body: 'Providers bid with discounts that scale as your group grows.' },
            ].map((c) => (
              <div key={c.title} className="flex items-start gap-3 bg-white rounded-lg border border-gray-100 p-4">
                <div className="w-9 h-9 rounded-lg bg-emerald-100 text-emerald-600 flex items-center justify-center shrink-0">
                  <c.icon className="w-5 h-5" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 text-sm">{c.title}</h3>
                  <p className="text-sm text-gray-600">{c.body}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default GroupBuyPromo;
